import { MapIconName } from '../../components/MapIcon';

export const POINTS_OF_INTEREST_SIMPLIFIED_MINZOOM = 9;
export const POINTS_OF_INTEREST_SIMPLIFIED_CIRCLE_RADIUS = 5;
export const POINTS_OF_INTEREST_MINZOOM = 12;
export const POINTS_OF_INTEREST_ICON_SIZE = 0.7;
export const SELECTED_POINT_OF_INTEREST_ICON_SIZE = 0.9;

export type PointOfInterestToggleableGroup =
  | 'RAMP'
  | 'MARINA'
  | 'BAIT_SHOP'
  | 'LICENSE_VENDOR'
  | 'CHARTER'
  | 'GEAR_AND_EQUIPMENT'
  | 'FLY_FISHING_SHOP'
  | 'REFUGE'
  | 'NATIONAL_PARK';

export interface PointOfInterest {
  typeId: number;
  layerId: string;
  name: string;
  icon: MapIconName;
  background: string;
  order: number;
  toggleableGroup: PointOfInterestToggleableGroup;
}

export interface PointsOfInterest {
  RAMP: PointOfInterest;
  MARINA: PointOfInterest;
  BAIT_SHOP: PointOfInterest;
  LICENSE_VENDOR: PointOfInterest;
  CHARTER: PointOfInterest;
  GEAR_AND_EQUIPMENT: PointOfInterest;
  FLY_FISHING_SHOP: PointOfInterest;
  REFUGE: PointOfInterest;
  NATIONAL_PARK: PointOfInterest;
}

export const POINTS_OF_INTEREST: PointsOfInterest = {
  RAMP: {
    typeId: 2,
    layerId: 'points_of_interest_layer_ramp',
    name: 'Boat Ramp',
    icon: 'poi_boatramp',
    background: '#EF9D53',
    order: 1,
    toggleableGroup: 'RAMP',
  },
  MARINA: {
    typeId: 4,
    layerId: 'points_of_interest_layer_marina',
    name: 'Marina',
    icon: 'poi_marina',
    background: '#EF9D53',
    order: 2,
    toggleableGroup: 'MARINA',
  },
  BAIT_SHOP: {
    typeId: 5,
    layerId: 'points_of_interest_layer_bait_shop',
    name: 'Bait Shop',
    icon: 'poi_baitshop',
    background: '#EF9D53',
    order: 3,
    toggleableGroup: 'BAIT_SHOP',
  },
  LICENSE_VENDOR: {
    typeId: 8,
    layerId: 'points_of_interest_layer_license_vendor',
    name: 'License Vendor',
    icon: 'poi_license_vendor',
    background: '#EF9D53',
    order: 4,
    toggleableGroup: 'LICENSE_VENDOR',
  },
  CHARTER: {
    typeId: 10,
    layerId: 'points_of_interest_layer_charter',
    name: 'Charter',
    icon: 'poi_charter',
    background: '#EF9D53',
    order: 5,
    toggleableGroup: 'CHARTER',
  },
  GEAR_AND_EQUIPMENT: {
    typeId: 11,
    layerId: 'points_of_interest_layer_gear_and_equipment',
    name: 'Gear and Equipment',
    icon: 'poi_gear_and_equipment',
    background: '#EF9D53',
    order: 6,
    toggleableGroup: 'GEAR_AND_EQUIPMENT',
  },
  FLY_FISHING_SHOP: {
    typeId: 13,
    layerId: 'points_of_interest_layer_fly_fishing_shop',
    name: 'Fly Fishing Shop',
    icon: 'poi_fly_shop',
    background: '#EF9D53',
    order: 7,
    toggleableGroup: 'FLY_FISHING_SHOP',
  },
  REFUGE: {
    typeId: 14,
    layerId: 'points_of_interest_layer_refuge',
    name: 'Fish Refuge or Hatchery',
    icon: 'poi_refuge',
    background: '#EF9D53',
    order: 8,
    toggleableGroup: 'REFUGE',
  },
  NATIONAL_PARK: {
    typeId: 16,
    layerId: 'points_of_interest_layer_national_park',
    name: 'National Park',
    icon: 'poi_national_park',
    background: '#757E5E',
    order: 9,
    toggleableGroup: 'NATIONAL_PARK',
  },
};

export const ALL_POI_TOGGLEABLE_GROUPS: PointOfInterestToggleableGroup[] = Object.values(
  POINTS_OF_INTEREST,
).map(({ toggleableGroup }) => toggleableGroup);
